require('dotenv').config();

module.exports = {
  basePath: '/listings',
  version: process.env.npm_package_version,
  graphqlApi: process.env.REACT_APP_GRAPHQL_API_BASE_URI,
  googleAnalyticsId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
  tagManagerId: process.env.REACT_APP_GTM_ID,
  segmentKey: process.env.REACT_APP_SEGMENT_KEY,
  baseUri: process.env.REACT_APP_BASE_URI,
  blockCrawlers: process.env.BLOCK_CRAWLERS === 'true',
  noIndexNoFollow: process.env.NO_INDEX_NO_FOLLOW === 'true',
  enableSchemas: process.env.ENABLE_SCHEMAS !== 'false',
  plaintextSupplierDescriptions: false,
  airtablePAT: process.env.REACT_APP_AIRTABLE_PAT,
  airtableApp: process.env.REACT_APP_AIRTABLE_APP_ID,
  airtableVenuesBaseId: process.env.REACT_APP_AIRTABLE_VENUES_BASE_ID,
  deployedEnvironment: process.env.REACT_APP_DEPLOYED_ENVIRONMENT || 'local',
  datadogApplicationId: process.env.DATADOG_APPLICATION_ID,
  datadogClientToken: process.env.DATADOG_CLIENT_TOKEN,
  reviewIoRedirect: process.env.REVIEW_IO_REDIRECT ?? '',
  prismicApiEndpoint: process.env.REACT_APP_PRISMIC_API_ENDPOINT,
  seoAdminBaseUrl: process.env.SEO_ADMIN_BASE_URL,
  seoAPIKey: process.env.SEO_ADMIN_API_KEY,
};
